var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-md shadow-sm flex gap-x-2 px-2 items-center w-max",class:_vm.getColorByType},[(_vm.getIconByType)?_c('fa-icon',{attrs:{"icon":_vm.getIconByType}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.getTextByType))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }